export default __webpack_public_path__ + "static/media/gallery_07.e7e33610.jpg";